export enum Page {
  Home = 'Home',
  HotQuestion = 'HotQuestion',
  Search = 'Search',
  Category = 'Category',
  Details = 'Details',
}
